import * as yup from 'yup';
import { buildRequiredEmailLikeSchema } from 'pages/Auth/utils';
import {
  SIGN_IN_IDENTIFIER_FORMAT_ERROR,
  SIGN_IN_IDENTIFIER_REQUIRED_ERROR,
  SIGN_IN_PASSWORD_REQUIRED_ERROR,
} from './SignIn.constants';

export const IDENTIFIER_SCHEMA = yup.object({
  identifier: buildRequiredEmailLikeSchema(SIGN_IN_IDENTIFIER_REQUIRED_ERROR, SIGN_IN_IDENTIFIER_FORMAT_ERROR),
});

export const PASSWORD_SCHEMA = yup.object({
  password: yup.string().required(SIGN_IN_PASSWORD_REQUIRED_ERROR),
});

export const TERMS_SCHEMA = yup.object({
  acceptTerms: yup.boolean().oneOf([true], 'You must accept the terms to continue.'),
});
